module.exports = __webpack_public_path__ + "img/blog-01.6fa1e864.jpg";